/**
 * Die Legende (HM-054).
 *
 * **Ab zwei Reihen ist sie Pflicht, bei einer ist sie Rauschen.** Farbe allein
 * darf eine Reihe nie kennzeichnen — wer die Größenfarben nicht gelernt hat
 * oder sie nicht unterscheiden kann, hätte sonst keinen Weg zur Zuordnung. Bei
 * einer einzelnen Reihe steht der Name dagegen in der Überschrift darüber, und
 * ein Kasten mit einem Eintrag wiederholt ihn nur.
 *
 * **Der Schlüssel bildet die Zeichnung nach:** ein Strich für eine Linie, ein
 * Rechteck für Fläche und Balken, ein gestrichelter Strich für die Linie der
 * rechten Achse (HM-137). Ein Rechteck neben einer Linie wäre ein zweites
 * Zeichen für dieselbe Sache.
 *
 * **Die Schrift trägt Textfarbe, nicht die Farbe der Reihe.** Gefärbter Text
 * liest sich schlechter und macht aus einer Beschriftung eine zweite
 * Datendarstellung; die Farbe steckt im Schlüssel daneben.
 */
import type { SeriesSlot } from "./frame.js";

export function ChartLegend({ rows }: { readonly rows: readonly SeriesSlot[] }) {
  return (
    <ul className="hm-chart-legend">
      {rows.map((row) => (
        <li key={row.id} className="hm-chart-legend-item">
          <span
            className={
              row.dashed
                ? "hm-chart-key-dashed"
                : row.mark === "line"
                  ? "hm-chart-key-line"
                  : "hm-chart-key-area"
            }
            style={row.dashed ? { color: row.color } : { background: row.color }}
            aria-hidden="true"
          />
          {row.label}
        </li>
      ))}
    </ul>
  );
}
